import { Suspense, lazy } from "react";
import { Navigate } from "react-router-dom";

import MainLayout from "../layouts/main";
import LogoOnlyLayout from "../layouts/LogoOnlyLayout";

import LoadingScreen from "../components/LoadingScreen";

const Loadable = (Component: React.ElementType) => (props: any) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks

  return (
    <Suspense
      fallback={
        null
        // <LoadingScreen
        //   sx={{
        //     ...(!isDashboard && {
        //       top: 0,
        //       left: 0,
        //       width: 1,
        //       zIndex: 9999,
        //       position: 'fixed'
        //     })
        //   }}
        // />
      }
    >
      <Component {...props} />
    </Suspense>
  );
};

// verify
const VerifyPhoneNumber = Loadable(
  lazy(() => import("../pages/register/VerifyPhoneNumber"))
);
const ChangePhoneNumber = Loadable(
  lazy(() => import("../pages/register/ChangePhoneNumber"))
);

// // invite
// const InviteHEAD = Loadable(lazy(() => import("../pages/register/InviteHEAD")));
// const InviteSHOP = Loadable(lazy(() => import("../pages/register/InviteSHOP")));

// // register
// const RegisterHEAD = Loadable(
//   lazy(() => import("../pages/register/RegisterHEAD"))
// );
// const RegisterSHOP = Loadable(
//   lazy(() => import("../pages/register/RegisterSHOP"))
// );
// const RegisterNORMAL = Loadable(
//   lazy(() => import("../pages/register/RegisterNORMAL"))
// );

// Main
const LandingPage = Loadable(lazy(() => import("../pages/LandingPage")));
const ComingSoon = Loadable(lazy(() => import("../pages/ComingSoon")));
const Maintenance = Loadable(lazy(() => import("../pages/Maintenance")));
const Page500 = Loadable(lazy(() => import("../pages/Page500")));
const NotFound = Loadable(lazy(() => import("../pages/Page404")));
const InfoAgree = Loadable(lazy(() => import("../pages/register/TermsAgreement")));


export const VERIFY_PHONE_NUMBER = [
  {
    path: "/",
    element: <VerifyPhoneNumber />,
  },
  {
    path: "/changePhoneNumber",
    element: <ChangePhoneNumber />,
  },
  // Main Routes
  {
    path: "*",
    element: <LogoOnlyLayout />,
    children: [
      { path: "coming-soon", element: <ComingSoon /> },
      { path: "maintenance", element: <Maintenance /> },
      { path: "500", element: <Page500 /> },
      { path: "404", element: <NotFound /> },
      { path: "*", element: <Navigate to="/404" replace /> },
    ],
  },
  { path: "*", element: <Navigate to="/404" replace /> },
];

export const REGISTER_HEAD = [
  // {
  //   path: '/register',
  //   element: <RegisterHEAD />
  // },
  //Main Routes
  {
    path: "*",
    element: <LogoOnlyLayout />,
    children: [
      { path: "coming-soon", element: <ComingSoon /> },
      { path: "maintenance", element: <Maintenance /> },
      { path: "500", element: <Page500 /> },
      { path: "404", element: <NotFound /> },
      { path: "*", element: <Navigate to="/404" replace /> },
    ],
  },
  { path: "*", element: <Navigate to="/404" replace /> },
];

export const REGISTER_NORMAL = [
  //   {
  //     path: "/",
  //     element: <RegisterNORMAL />,
  //   },
  // Main Routes
  {
    path: "*",
    element: <LogoOnlyLayout />,
    children: [
      { path: "coming-soon", element: <ComingSoon /> },
      { path: "maintenance", element: <Maintenance /> },
      { path: "500", element: <Page500 /> },
      { path: "404", element: <NotFound /> },
      { path: "*", element: <Navigate to="/404" replace /> },
    ],
  },
  { path: "*", element: <Navigate to="/404" replace /> },
];

// export const REGISTER_SHOP = [
//   //   {
//   //     path: "/",
//   //     element: <InviteSHOP />,
//   //   },
//   //   {
//   //     path: "/register",
//   //     element: <RegisterSHOP />,
//   //   },
//   // Main Routes
//   {
//     path: "*",
//     element: <LogoOnlyLayout />,
//     children: [
//       { path: "coming-soon", element: <ComingSoon /> },
//       { path: "maintenance", element: <Maintenance /> },
//       { path: "500", element: <Page500 /> },
//       { path: "404", element: <NotFound /> },
//       { path: "*", element: <Navigate to="/404" replace /> },
//     ],
//   },
//   { path: "*", element: <Navigate to="/404" replace /> },
// ];

export const REGISTER_SHOP = [
    {
      path: "/",
      element: <InfoAgree />,
    },
    // {
    //   path: "/register",
    //   element: <RegisterSHOP />,
    // },
  // Main Routes
  {
    path: "*",
    element: <LogoOnlyLayout />,
    children: [
      { path: "coming-soon", element: <ComingSoon /> },
      { path: "maintenance", element: <Maintenance /> },
      { path: "500", element: <Page500 /> },
      { path: "404", element: <NotFound /> },
      { path: "*", element: <Navigate to="/404" replace /> },
    ],
  },
  { path: "*", element: <Navigate to="/404" replace /> },
];
